export default {
    data () {
        return {
            pickerOptions: {
                disabledDate: this.disabledDate
            }
        }
    },
    methods: {
        disabledDate (date) {
            return date > new Date()
        }
    }
}
